import { createRedesignEntry } from "../redesign-page-entry";

export default createRedesignEntry(() => import("./clinic-form-page"), {
  testId: "rd-clinic-loading",
  // «Мой профиль» → «Добавить клинику».
  shell: {
    breadcrumbRoot: { id: "redesign.profile.title", defaultMessage: "My profile", to: "/pages/my_account" },
    breadcrumbLeaf: { id: "redesign.clinic.title", defaultMessage: "Add clinic" },
  },
});
